export default __webpack_public_path__ + "static/media/countordenes.37c5ae98.png";